<div class="loading" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>
<div class="layout" *ngIf="!loading">
  <app-sidenav class="sidenav_class"></app-sidenav>
  <div class="content">
    <div class="requestor-blocked-banner" role="alert" *ngIf="blockState.blocked$ | async as blocked">
      <strong>Your account is blocked from making changes.</strong>
      {{ blocked.message || 'Requestor is blocked until an administrator unblocks them.' }}
      You can still view information. Reload the page after an administrator unblocks you.
    </div>
    <router-outlet class="router_class"></router-outlet>
  </div>
</div>